var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retr__content"},_vm._l((_vm.retr.list),function(manufacturer,index){return _c('retr-current-manufacturer-row',{key:`manufacturer-${manufacturer.manufacturer_id}-${index}`,ref:`manufacturer-${index}`,refInFor:true,attrs:{"manufacturer":manufacturer}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }